import { useCallback, useState } from "react";
import { NavLink } from "react-router-dom";

import { IS_UNIVERSAL_PARTNER } from "../../../../constants/host-name";
import { NAVIGATION_ITEMS, RoutePaths, T } from "../../../../constants";
import { useTranslation } from "../../../../hooks";
import Permission from "../../shared/permission";
import { Button, Icon } from "../../shared";
import { Icons } from "../../../../enums";

interface SidebarProps {
  disableMenuList: boolean;
  businessId: number;
}

export const Sidebar: React.FC<SidebarProps> = ({
  disableMenuList,
  businessId,
}) => {
  const [open, setOpen] = useState(false);
  const [subMenu, setSubMenu] = useState('');
  const [toggleMenu, setToggleMenu] = useState(false);

  const t = useTranslation();

  const handleClick = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const generatePathById = useCallback((path: string, redirectById?: boolean) => {
    return redirectById ? `${path}/${businessId}/edit` : path;
  }, []);

  const handleOpenSubMenu = useCallback((path: string) => {
    setSubMenu(path);
    setToggleMenu((prevState) => !prevState);
  }, [setSubMenu, setToggleMenu]);

  return (
    <div className={`sidebar-holder ${open ? "" : "closed"}`}>
      <div className="sidebar-button">
        <Button
          size="sm"
          iconSize="xs"
          onClick={handleClick}
          icon={Icons.ArrowLeft}
        />
      </div>
      <div className="sidebar-holder-inner">
        <div className="sidebar-head-row">
          {!IS_UNIVERSAL_PARTNER ? (
            <NavLink to={RoutePaths.Dashboard} className="logo-container" />
          ) : null}
        </div>
        <div className="sidebar-main-cont">
          <ul className="sidebar-main-cont-inner scrollable-container vertical">
            {NAVIGATION_ITEMS.map(
              ({ path, label, icon, accessedUserTypes, redirectById, sub }) => (
                <Permission key={path + label} accessedUserTypes={accessedUserTypes}>
                  <li onClick={() => handleOpenSubMenu(path)} className={`sidebar-sub-menu-holder ${path === subMenu && toggleMenu ? 'active' : '' }`}>
                    <NavLink
                      to={generatePathById(path, redirectById)}
                      onClick={(e) => sub?.length && e.preventDefault()}
                      className={({ isActive }) => `${isActive && !sub?.length ? "active" : ""} menu-row ${disableMenuList && label !== T.DASHBOARD ? "disabled" : ""}`}
                    >
                      <div className="menu-items-holder">
                        <Icon className="sidebar-icon" type={icon} />
                        <span className="sidebar-text">{t(label)} </span>
                      </div>
                      {
                        sub?.length && (
                          <div className="sub-menu-opener-icon-holder">
                            <i className="icon-arrow-down"/>
                          </div>
                        )
                      }
                    </NavLink>
                    {
                      <ul className="sidebar-sub-menu">
                        {
                          sub?.map(({path, label, icon, accessedUserTypes, redirectById}) => (
                            <Permission key={path + label} accessedUserTypes={accessedUserTypes}>
                              <li className="sidebar-sub-menu-el">
                                <NavLink
                                  to={generatePathById(path, redirectById)}
                                  className={({isActive}) => `${isActive ? "active" : ""} menu-row`}
                                >
                                  <Icon className="sidebar-icon" type={icon}/>
                                  <span className="sidebar-text">{t(label)}</span>
                                </NavLink>
                              </li>
                            </Permission>
                          ))
                        }
                      </ul>
                    }
                  </li>
                </Permission>
              ),
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
